import { withTranslation } from "next-i18next";
import GiftCardNavbar from "./GiftCardNavbar";
import GiftCardForms from "./GiftCardForms";
import GiftCardOption from "../Shared/GiftCardOption";

function GiftCardInformations({
  amount,
  standardGiftCard = true,
  t,
}) {
  return (
    <div>
      <GiftCardNavbar />
      <h4 className="text-center my-4 pb-2">{t("gift_cards:gift_card_informations_title")}</h4>
      <div style={{ maxWidth: "100%", width: "220px" }} className="d-flex mx-auto">
        <GiftCardOption
          amount={amount}
          buyGiftCardsInformationsPage
        />
      </div>
      <div className="d-flex justify-content-center">
        <GiftCardForms
          standardGiftCard={standardGiftCard}
          amount={amount}
        />
      </div>
    </div>
  );
}

export default withTranslation("gift_cards")(GiftCardInformations);
